export default __webpack_public_path__ + "cover.38b2d002512f8ec7f1bdbfdd2d42b1c4.jpg"